import { Column, Entity, JoinColumn, ManyToOne, OneToMany } from "typeorm";
import { Answer } from "./answer.entity";
import { CommonColumns } from "./common-columns.entity";
import { QuestionHeader } from "./question-header.entity";
import { ShopToken } from "./shop-token.entity";
import { Shop } from "./shop.entity";

export enum AnswerMode {
  TEST = 'test',
  NORMAL = 'normal',
}

@Entity()
export class AnswerHeader extends CommonColumns {

  // 誤って回答結果がQuestionHeaderにくっついてクライアント側に送信されると大問題になる
  // 敢えて逆側の参照は持たせない
  @ManyToOne(() => Shop, { nullable: false, })
  @JoinColumn({ name: 'shop_id', referencedColumnName: 'id', })
  shop?: Shop;

  @Column({ name: 'shop_id', })
  shopId: number;

  // 誤って回答結果がQuestionHeaderにくっついてクライアント側に送信されると大問題になる
  // 敢えて逆側の参照は持たせない
  @ManyToOne(() => QuestionHeader, { nullable: false, })
  @JoinColumn({ name: 'question_header_id', referencedColumnName: 'id', })
  questionHeader?: QuestionHeader;

  @Column({ name: 'question_header_id', })
  questionHeaderId: number;

  @ManyToOne(() => ShopToken, { nullable: false, })
  @JoinColumn({ name: 'shop_token_id', referencedColumnName: 'id', })
  shopToken?: ShopToken;

  @Column({ name: 'shop_token_id', })
  shopTokenId: number;

  @Column({
    name: 'answer_mode',
    enum: AnswerMode,
    default: AnswerMode.NORMAL,
  })
  answerMode: AnswerMode;

  @Column({ name: 'read_at', type: 'timestamptz', })
  readAt: Date;
  
  @Column({ name: 'answered_at', type: 'timestamptz', nullable: true, })
  answeredAt: Date|null;

  @OneToMany(() => Answer, answer => answer.answerHeader)
  answers: Answer[];

  constructor(props: TAnswerHeader) {
    super();
    Object.assign(this, props);
  }
}

export declare type TAnswerHeader = Omit<AnswerHeader, 'dummy-no-such-field'>;
export interface IAnswerHeader extends TAnswerHeader {};
